export enum AiDocumentType {
   Other = 1,
   PmAccounts = 2,
   CreditLimit = 3,
   ComplimentaryRooms = 4,
   OutOfOrderRooms = 5,
   NoShowRooms = 6,
   HousekeepingDiscrepancy = 7,
   PaidOut = 8,
   KeyRegister = 9,
   RevenueAdjustment = 10,
   TaComm = 11,
   RateChange = 12,
   PaymentRefunds = 13
}
